
import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { KmkMACacheViewModel } from './kmkMACacheViewModel';

export class KmkMA_SubCacheContainer extends MasterDataContainer<KmkMACacheViewModel> {
    constructor(models: Array<KmkMACacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
